import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
import styles from "./Radio.module.scss.js";
const radioVariants = cva(
  [
    styles["radio"],
    "bg-transparent border border-grayscale-300 align-top cursor-pointer w-[1em] h-[1em] rounded-full text-base"
  ],
  {
    variants: {
      color: {
        primary: ["text-primary"],
        success: ["text-success"],
        danger: ["text-danger"],
        warning: ["text-warning"],
        inherit: ["text-inherit"]
      },
      disabled: {
        true: ["bg-grayscale-100 opacity-60"],
        false: []
      }
    },
    defaultVariants: {
      disabled: false,
      color: "primary"
    }
  }
);
const Radio = forwardRef((props, ref) => {
  const { color, disabled, className, onCheckedChange, onChange, ...rest } = props;
  const handleChange = (e) => {
    onChange == null ? void 0 : onChange(e);
    onCheckedChange == null ? void 0 : onCheckedChange(e.target.checked);
  };
  return /* @__PURE__ */ jsx(
    "input",
    {
      ...rest,
      ref,
      type: "radio",
      disabled,
      onChange: handleChange,
      className: twMerge(radioVariants({ color, disabled, className }))
    }
  );
});
export {
  Radio as default
};
//# sourceMappingURL=Radio.js.map
